import React, { useEffect } from 'react';
import { ProofOfPaymentOnboarding as View } from '@views';
import { trackEvent } from '@utils/mixpanel';
import { useLocation } from 'react-router-dom';

const ProofOfPaymentOnboarding = () => {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = 'Mindspace: Proof of Payment';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Proof Of Payment - Onboarding',
    });
  }, []);

  return <View direction={location?.state?.direction} />;
};

export default ProofOfPaymentOnboarding;
